import { useState, useMemo, useCallback, useLayoutEffect } from "react";
import debounce from "lodash/debounce.js";
const useElementSize = (ref, initialOptions = {}) => {
  var _a, _b;
  const [size, setSize] = useState({
    width: 0,
    height: 0
  });
  const { debounce: debounceTime, includeScrollWidth } = useMemo(
    () => ({
      includeScrollWidth: false,
      debounce: 300,
      ...initialOptions
    }),
    [initialOptions]
  );
  const handleResize = useCallback(
    debounce(() => {
      if (ref && ref.current) {
        setSize({
          width: ref.current[includeScrollWidth ? "scrollWidth" : "offsetWidth"],
          height: ref.current[includeScrollWidth ? "scrollHeight" : "offsetHeight"]
        });
      }
    }, debounceTime),
    [ref.current, includeScrollWidth]
  );
  useLayoutEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [(_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.offsetHeight, (_b = ref == null ? void 0 : ref.current) == null ? void 0 : _b.offsetWidth, includeScrollWidth]);
  return size;
};
export {
  useElementSize
};
